import { observable } from 'mobx';

export type OrganizationOperationRuleFieldResponseArgs = {
  api_name: string;
  label: string;
  value: string;
};

export type OrganizationOperationRuleFieldArgs = {
  apiName: string;
  label: string;
  value: string;
};

export const convertOrganizationOperationRuleFieldResponseToArgs = (
  response: OrganizationOperationRuleFieldResponseArgs
): OrganizationOperationRuleFieldArgs => ({
  apiName: response.api_name,
  label: response.label,
  value: response.value ?? ''
});

export default class OrganizationOperationRuleField {
  @observable apiName: string;
  @observable label: string;
  @observable value: string;

  constructor(args: OrganizationOperationRuleFieldArgs) {
    this.apiName = args.apiName;
    this.label = args.label;
    this.value = args.value;
  }
}
